(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("react-dom"), require("@feature-hub/react"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "react-dom", "@feature-hub/react"], factory);
	else if(typeof exports === 'object')
		exports["model-overview"] = factory(require("react"), require("styled-components"), require("react-dom"), require("@feature-hub/react"));
	else
		root["model-overview"] = factory(root["react"], root["styled-components"], root["react-dom"], root["@feature-hub/react"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__155__, __WEBPACK_EXTERNAL_MODULE__694__, __WEBPACK_EXTERNAL_MODULE__514__, __WEBPACK_EXTERNAL_MODULE__544__) => {
return 